var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28596 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28596 2 4.92893 3.46447 3.46447Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 17.5C12.75 17.9142 12.4142 18.25 12 18.25C11.5858 18.25 11.25 17.9142 11.25 17.5V11.5C11.25 9.70508 9.79493 8.25 8 8.25H7.81066L8.03033 8.46967C8.32322 8.76256 8.32322 9.23744 8.03033 9.53033C7.73744 9.82322 7.26256 9.82322 6.96967 9.53033L5.46967 8.03033C5.17678 7.73744 5.17678 7.26256 5.46967 6.96967L6.96967 5.46967C7.26256 5.17678 7.73744 5.17678 8.03033 5.46967C8.32322 5.76256 8.32322 6.23744 8.03033 6.53033L7.81066 6.75H8C9.67947 6.75 11.1554 7.62162 12 8.93719C12.8446 7.62162 14.3205 6.75 16 6.75H16.1893L15.9697 6.53033C15.6768 6.23744 15.6768 5.76256 15.9697 5.46967C16.2626 5.17678 16.7374 5.17678 17.0303 5.46967L18.5303 6.96967C18.8232 7.26256 18.8232 7.73744 18.5303 8.03033L17.0303 9.53033C16.7374 9.82322 16.2626 9.82322 15.9697 9.53033C15.6768 9.23744 15.6768 8.76256 15.9697 8.46967L16.1893 8.25H16C14.2051 8.25 12.75 9.70508 12.75 11.5V17.5Z",
    fill: "#D4D4DD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.4bfcc0942c076e04ee8027ecb499cab8.svg";
export { ForwardRef as ReactComponent };